import React from 'react';
import { isFunction } from 'lodash/lang';
import { AnalyticsConsumer } from '../providers/AnalyticsProvider';

const withClickAnalytics = (analyticsConsumerProps) => (WrappedComponent) =>
  function AnalyticsHOCComponent({
    analyticsActionName,
    analyticsLabel,
    analyticsCustomOptions,
    onClick,
    ...rest
  }) {
    return (
      <AnalyticsConsumer {...analyticsConsumerProps}>
        {({ sendAction, dataProps }) => (
          <WrappedComponent
            onClick={(...eventArgs) => {
              if (isFunction(onClick)) {
                onClick(...eventArgs);
              }
              sendAction(analyticsActionName, analyticsLabel, analyticsCustomOptions);
            }}
            {...dataProps}
            {...rest}
          />
        )}
      </AnalyticsConsumer>
    );
  };

export default withClickAnalytics;
